import React from 'react';
import { CircularProgress, Typography, useTheme } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { type StatutJsonldStatutRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import useStatusStyle from '../../../../../hooks/useStatusStyle';

type StatusChipProps = {
    status: StatutJsonldStatutRead;
    isCurrent: boolean;
    isClickable: boolean;
    isProcessing: boolean;
    onTransitionClick?: () => void;
};

const StatusChip: React.FunctionComponent<StatusChipProps> = function ({
    status,
    isCurrent,
    isClickable,
    isProcessing,
    onTransitionClick,
}) {
    const { palette } = useTheme();
    const { getDossierStatusStyle } = useStatusStyle();
    const statusStyle = getDossierStatusStyle(status.id as number);

    const getChipSx = () => {
        if (isCurrent) {
            return { ...statusStyle.sxStatus, height: '22px', fontSize: '11px' };
        }
        if (isClickable) {
            return {
                border: `1px solid ${palette.grey[300]}`,
                color: palette.grey[700],
                background: 'transparent',
                height: '22px',
                fontSize: '11px',
                cursor: 'pointer',
                '&:hover': { backgroundColor: palette.grey[100] },
            };
        }
        return {
            border: `1px solid ${palette.grey[200]}`,
            color: palette.grey[400],
            background: 'transparent',
            height: '22px',
            fontSize: '11px',
        };
    };

    return (
        <InformationChip
            sx={getChipSx()}
            sxIcon={{
                display: isCurrent ? 'flex' : 'none',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            icon={isCurrent ? (statusStyle.iconProp as IconProp) : undefined}
            label={
                isProcessing ? (
                    <CircularProgress
                        size="10px"
                        color="inherit"
                    />
                ) : (
                    <Typography
                        variant="l2dbodys"
                        sx={{ fontSize: '11px' }}
                        onClick={isClickable ? onTransitionClick : undefined}
                    >
                        {status.libelle}
                    </Typography>
                )
            }
        />
    );
};

export default StatusChip;
